import { cn } from "@/libs/utils";

const Spinning = ({ className = "" }) => {
  return (
    <div
      className={cn(
        className,
        "pointer-events-none relative",
        "after:absolute after:left-0 after:top-0 after:content-['']",
        "after:block after:h-full after:w-full",
        "after:rounded-full after:border-2 after:border-current",
        "after:border-r-transparent after:border-t-transparent",
        "after:animate-spin",
      )}
    />
  );
};

export default Spinning;
